import * as tslib_1 from "tslib";
import { addComposePlugins } from './ComposePlugins';
import ContentOperationPlugin from './contentOperation/ContentOperationPlugin';
import DockingPlugin from './docking/DockingPlugin';
import StickyDockingPlugin from './docking/StickyDockingPlugin';
import preloadComposePlugins from '../actions/preloadComposePlugins';
import switchToReadWriteRecipient from '../actions/switchToReadWriteRecipient';
import canModifyRecipients from '../utils/canModifyRecipients';
import createAttachments from '../utils/createAttachments';
import deletePendingInlineAttachment from '../utils/deletePendingInlineAttachment';
import fixInlineImageSrc from '../utils/fixInlineImageSrc';
import { infoBarAddHandler, infoBarRemoveHandler } from '../utils/infoBarHandlers';
import { LazyAttachmentPluginClass } from 'owa-attachment-editor-plugin';
import { isAttachmentFeatureEnabled } from 'owa-attachment-feature-flags';
import { LazyAccCheckerPluginClass } from 'owa-editor-acc-checker-plugin';
import { AddinEditorPlugin } from 'owa-addins-editor-plugin';
import { LazyEmojiPluginClass } from 'owa-editor-emojiplugin';
import { LazyAtMentionsPluginClass } from 'owa-editor-mentionsplugin';
import { LazyPasteOptionPluginClass } from 'owa-editor-paste-option-plugin';
import { LazyAtMentionsPickerPluginClass } from 'owa-editor-picker-plugin';
import MentionPluginDataProvider from 'owa-editor-picker-plugin/lib/providers/MentionPluginDataProvider';
import RibbonPlugin from 'owa-editor-ribbonplugin/lib/plugin/RibbonPlugin';
import { LazySmartSuggestionsPluginClass } from 'owa-editor-smart-suggestions-plugin';
import { TableEditPlugin } from 'owa-editor-table-edit-plugin';
import { LazyLinkPreviewPluginClass } from 'owa-link-preview-compose';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { InlineImagePlugin, LazyInlineImageResizePluginClass, lazyGetSelectedImage, } from 'owa-inline-image';
function getCreateAttachmentsHandler(viewState) {
    return function (files, isInline, shouldShare, isHiddenInline, processInlineImageBeforeUploadFunc) {
        createAttachments(files, isInline, viewState, shouldShare, isHiddenInline, processInlineImageBeforeUploadFunc);
    };
}
function getDeleteInlineAttachmentsHandler(viewState) {
    return function (placeholderId) {
        deletePendingInlineAttachment(placeholderId, viewState);
    };
}
function getAttachmentStatesHandler(viewState) {
    return function () { return viewState.attachmentWell.inlineAttachments; };
}
export default function createComposePlugins(viewState, undo) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var dockingPlugin, scrollAdapter, inlineImagePlugin, emojiPlugin, atMentionsPlugin, pickerPlugin, switchToReadWriteRecipientWell, isRtl, composePlugins;
        return tslib_1.__generator(this, function (_a) {
            dockingPlugin = viewState.docking.useStickyDocking
                ? new StickyDockingPlugin(viewState.docking)
                : new DockingPlugin(viewState.docking);
            scrollAdapter = dockingPlugin.getScrollAdapter();
            inlineImagePlugin = new InlineImagePlugin(getAttachmentStatesHandler(viewState), getCreateAttachmentsHandler(viewState), getDeleteInlineAttachmentsHandler(viewState), fixInlineImageSrc(viewState));
            emojiPlugin = new LazyEmojiPluginClass(viewState.emoji, scrollAdapter, true /*useFlexPane*/);
            atMentionsPlugin = null;
            pickerPlugin = null;
            if (isMailFeatureEnabled('cmp-mentions')) {
                switchToReadWriteRecipientWell = function (viewState) { return function () {
                    if (viewState.showCompactRecipientWell) {
                        switchToReadWriteRecipient(viewState);
                    }
                }; };
                if (isMailFeatureEnabled('cmp-newMentionPlugin')) {
                    pickerPlugin = new LazyAtMentionsPickerPluginClass(new MentionPluginDataProvider(viewState.atMentions, scrollAdapter, viewState.toRecipientWell, switchToReadWriteRecipientWell(viewState), canModifyRecipients(viewState)), {
                        elementIdPrefix: 'OWAAM',
                        changeSource: 'AtMention',
                        triggerCharacter: '@',
                    });
                }
                else {
                    atMentionsPlugin = new LazyAtMentionsPluginClass(viewState.atMentions, scrollAdapter, viewState.toRecipientWell, switchToReadWriteRecipientWell(viewState), canModifyRecipients(viewState));
                }
            }
            isRtl = getUserConfiguration().SessionSettings.IsUserCultureRightToLeft;
            composePlugins = {
                undo: undo,
                dockingPlugin: dockingPlugin,
                ribbonPlugin: new RibbonPlugin(viewState.ribbon, lazyGetSelectedImage.import()),
                inlineImagePlugin: inlineImagePlugin,
                inlineImageResizePlugin: new LazyInlineImageResizePluginClass(scrollAdapter),
                emojiPlugin: emojiPlugin,
                editorPickerPlugin: pickerPlugin,
                atMentionsPlugin: atMentionsPlugin,
                contentOperationPlugin: new ContentOperationPlugin(viewState),
                smartSuggestionsPlugin: isMailFeatureEnabled('mc-smartSuggestions')
                    ? new LazySmartSuggestionsPluginClass(emojiPlugin)
                    : null,
                linkPreviewPlugin: new LazyLinkPreviewPluginClass(scrollAdapter),
                addinPlugin: isMailFeatureEnabled('rp-addins') ? new AddinEditorPlugin() : null,
                pasteOptionPlugin: isMailFeatureEnabled('cmp-pasteOption')
                    ? new LazyPasteOptionPluginClass(viewState.pasteOption, scrollAdapter, isRtl)
                    : null,
                tableEdit: new TableEditPlugin(viewState.tableEdit),
                accCheckerPlugin: isMailFeatureEnabled('cmp-accChecker')
                    ? new LazyAccCheckerPluginClass(viewState.accChecker)
                    : null,
                attachmentPlugin: isAttachmentFeatureEnabled('doc-attachment-sharingTips')
                    ? new LazyAttachmentPluginClass(viewState.attachmentWell, viewState, infoBarAddHandler(viewState), infoBarRemoveHandler(viewState))
                    : null,
            };
            // Setting the current compose plugins to the newly created one
            addComposePlugins(viewState, composePlugins);
            preloadComposePlugins(viewState);
            return [2 /*return*/, composePlugins];
        });
    });
}
//# sourceMappingURL=createComposePlugins.js.map